import { IOfferSpendByOfferDetailsTableLang } from '../../../types/lang'

export const offerSpendByOfferDetailsTableLang: IOfferSpendByOfferDetailsTableLang = {
	offer_spend_by_offer_details_table: {
		column_id: 'ID',
		column_date: 'Date',
		column_amount: 'Amount',
		column_account: 'Account',
		column_kt_group: 'KT Group',
		column_notes: 'Notes',
	}
}